import { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { getFAQs } from '../lib/api';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const FAQsPage = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        const res = await getFAQs();
        setFaqs(res.data);
      } catch (error) {
        console.error('Error fetching FAQs:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchFAQs();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-neutral-900"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white" data-testid="faqs-page">
      <Navbar />
      
      {/* Header */}
      <section className="pt-24 sm:pt-32 pb-12 sm:pb-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 text-center">
          <p className="text-xs sm:text-sm font-semibold tracking-widest uppercase text-neutral-500 mb-3 sm:mb-4">Got Questions?</p>
          <h1 className="text-3xl sm:text-5xl md:text-7xl font-extrabold tracking-tight leading-tight text-neutral-900 mb-4 sm:mb-6" style={{ fontFamily: 'Syne, sans-serif' }}>FAQs</h1>
          <p className="text-base sm:text-lg md:text-xl leading-relaxed text-neutral-500 max-w-2xl mx-auto px-4">
            Find answers to commonly asked questions about our DJ services.
          </p>
        </div>
      </section>

      {/* FAQs */}
      <section className="py-12 sm:py-16 md:py-24 bg-neutral-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 md:px-12">
          {faqs.length === 0 ? (
            <div className="text-center py-12 sm:py-16">
              <p className="text-base sm:text-lg md:text-xl leading-relaxed text-neutral-500">No FAQs available yet. Check back soon!</p>
            </div>
          ) : (
            <Accordion type="single" collapsible className="space-y-3 sm:space-y-4">
              {faqs.map((faq) => (
                <AccordionItem 
                  key={faq.id} 
                  value={faq.id}
                  className="bg-white border border-neutral-100 px-4 sm:px-6"
                  data-testid={`faq-${faq.id}`}
                >
                  <AccordionTrigger className="text-left py-4 sm:py-6 hover:no-underline">
                    <span className="font-bold text-base sm:text-lg pr-4" style={{ fontFamily: 'Syne, sans-serif' }}>{faq.question}</span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-4 sm:pb-6">
                    <p className="text-sm sm:text-base leading-relaxed text-neutral-500 whitespace-pre-wrap">{faq.answer}</p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          )}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 sm:py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 text-center">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-4 sm:mb-6" style={{ fontFamily: 'Syne, sans-serif' }}>Still Have Questions?</h2>
          <p className="text-base sm:text-lg md:text-xl leading-relaxed text-neutral-500 max-w-2xl mx-auto mb-6 sm:mb-8 px-4">
            Feel free to reach out to us directly. We're happy to help!
          </p>
          <a href="/contact" className="bg-neutral-900 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold transition-all duration-300 hover:scale-105 hover:shadow-xl shadow-lg shadow-neutral-900/20 inline-block text-sm sm:text-base">
            Contact Us
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQsPage;
